// // import React from "react";
// // import SincanSidebar from "../Sidebar/SincanSidebar";
// // import SincanServiceArea from "../ServiceAreas/SincanServiceArea";
// // import RightSidebar from "../../Sidebars/RightSidebar";
// // import LeftSidebar from "../../Sidebars/LeftSidebar";

// // const SincanIntro = () => {
// //   return (
// //     <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
     
// //       <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
// //         SİNCAN HALI VE KOLTUK YIKAMA
// //       </h1>

// //       {/* 3 Sütunlu Grid */}
// //       <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
// //         {/* İçerik Orta Alan */}
// //         <div className="order-1 md:order-2 md:col-span-2 space-y-6">
// //           <p>
// //             Sincan'da profesyonel halı ve koltuk yıkama hizmetleri ile hijyen ve
// //             kaliteyi bir araya getiriyoruz. Abone Halı Yıkama halılarınızı,
// //             koltuklarınızı ve ev tekstil ürünlerinizi %100 müşteri memnuniyeti
// //             odaklı bir hizmet anlayışıyla teslim alır, özel sistemlerle detaylı
// //             şekilde yıkar ve zamanında geri teslim eder.
// //           </p>

// //           <p>
// //             Evde çocuk, yaşlı veya alerjik bireyler varsa, temizlik kalitesine
// //             güvenmek sizin en doğal hakkınız. Abone Halı Yıkama olarak yalnızca
// //             yüzeysel temizleme değil, derinlemesine hijyen sağlayan özel yıkama
// //             yöntemleri kullanıyoruz.
// //           </p>

// //           <h2 className="text-lg font-semibold text-[#003132]">
// //             Neden Abone Halı Yıkama?
// //           </h2>
// //           <ul className="list-disc list-inside">
// //             <li>Sağlıklı ve hijyenik temizlik çözümleri</li>
// //             <li>Antibakteriyel ve alerjenlerden arındırılmış hijyen</li>
// //             <li>Yerinde yıkama & fabrikada yıkama seçeneği</li>
// //             <li>Organik ve çevre dostu temizleme teknikleri</li>
// //             <li>Kısa sürede teslimat garantisi</li>
// //             <li>Derinlemesine leke çıkarma garantisi</li>
// //           </ul>

// //           <p>
// //             Sincan'daki hizmet bölgelerimiz arasında Törekent, Yenikent, Fatih
// //             ve Sincan'daki tüm mahalleler bulunmaktadır. Mobil araçlarımız
// //             sayesinde aynı gün içinde yerinden alım ve teslimat hizmeti
// //             sunuyoruz.
// //           </p>

// //           <p>
// //             Koltuk yıkama işlemlerinde kumaşın yapısına zarar vermeyen, etkili
// //             şampuanlar ve buharlı sistemlerle hijyen sağlıyoruz. Halılarınız
// //             özel filelerle paketlenerek güvenli bir şekilde teslim edilir.
// //           </p>

// //           <p>
// //             Hizmet verdiğimiz tüm mahallelerde, profesyonel ve güler yüzlü
// //             personelimizle çalışıyoruz. Abone Halı Yıkama olarak
// //             müşterilerimizin memnuniyeti her zaman önceliğimizdir!
// //           </p>

// //           <p>
// //             Hemen <strong>İletişim</strong> sayfamızdan bize ulaşarak sipariş
// //             verebilir veya fiyat bilgisi alabilirsiniz.
// //           </p>

// //           <SincanSidebar />
// //           <SincanServiceArea />
// //         </div>

// //         {/* Sol Sidebar */}
// //         <div className="order-2 md:order-1 space-y-6">
// //           <LeftSidebar />
// //         </div>

// //         {/* Sağ Sidebar */}
// //         <div className="order-3 md:order-3 space-y-6">
// //           <RightSidebar />
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default SincanIntro;
// import React from "react";
// import SincanSidebar from "../Sidebar/SincanSidebar";
// import SincanServiceArea from "../ServiceAreas/SincanServiceArea";
// import RightSidebar from "../../Sidebars/RightSidebar";
// import LeftSidebar from "../../Sidebars/LeftSidebar";

// const SincanIntro = () => {
//   return (
//     <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
//       <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
//         SİNCAN HALI YIKAMA
//       </h1>

//       {/* 3 Sütunlu Grid */}
//       <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
//         {/* İçerik Orta Alan */}
//         <div className="order-1 md:order-2 md:col-span-2 space-y-6">
//           <p>
//             Sincan'da halı yıkama fiyatları, koltuk yıkama hizmet kalitesi ve
//             yerinde yıkama çözümleriyle öne çıkan firmamız, sizlere güvenilir,
//             hızlı ve hijyenik bir temizlik sunar. Google'da en çok aranan{" "}
//             <strong>sincan halı yıkama</strong> ve{" "}
//             <strong>sincan koltuk yıkama firmaları</strong> arasında tavsiye
//             edilen öncü konumdayız.
//           </p>

//           <p>
//             Ev ortamınızda güvenli bir hijyen için{" "}
//             <strong>sincan buharlı koltuk yıkama</strong> ve{" "}
//             <strong>sincan yerinde halı yıkama</strong> hizmetlerimizle tüm
//             mahallelerde yerinde hizmet veriyoruz. Kumaşa zarar vermeyen özel
//             şampuanlar ve yüksek vakumlu makinelerle evinizi yormadan temizlik
//             sağlıyoruz.
//           </p>

//           <h2 className="text-lg font-semibold text-[#003132]">
//             Neden Abone Halı Yıkama?
//           </h2>
//           <ul className="list-disc list-inside">
//             <li>Sincan koltuk yıkama tavsiye edilen ekip ve makineler</li>
//             <li>Halı yıkama fiyatlarında net, şeffaf ve ekonomik çözümler</li>
//             <li>Stor, zebra ve tül perde yıkamada garanti hizmet</li>
//             <li>Organik, çevre dostu ve antibakteriyel temizlik ürünleri</li>
//             <li>Yerinde buharlı halı yıkama sistemi ile anında çözüm</li>
//             <li>Sincan'da en çok önerilen halı yıkama firmalarından biri</li>
//           </ul>

//           <p>
//             Özellikle <strong>sincan stor perde yıkama</strong> ve{" "}
//             <strong>sincan zebra perde yıkama</strong> hizmetimiz, evinde geniş
//             camlara sahip olan müşterilerimiz için profesyonel ütülü teslimatla
//             sunulmaktadır. Kırışıklık önleyici sistemler ve düşük ısıda kurutma
//             ile mükemmel sonuçlar sağlıyoruz.
//           </p>

//           <p>
//             Koltuk yıkama hizmetimizde{" "}
//             <strong>sincan yerinde koltuk yıkama</strong> ve{" "}
//             <strong>sincan buharlı koltuk temizleme</strong> işlemleri öne
//             çıkmaktadır. Kumaşın türüne göre analiz yapıyor, özel formüllerle
//             lekelere doğrudan müdahale ediyoruz.
//           </p>

//           <p>
//             <strong>Sincan halı yıkama fiyatları</strong> hakkında net bilgiye
//             ulaşmak için iletişime geçebilirsiniz. Fiyatlarımız her halı
//             türüne, boyutuna ve yıkama yöntemine göre şeffaf şekilde
//             belirlenmektedir. Ekstra ücret ya da gizli maliyet yoktur.
//           </p>

//           <p>
//             Halılarınız özel torbalarda, yıpranmadan ve toz geçirmez şekilde
//             teslim edilir. Koltuklarınız yerinde yıkanır, kısa sürede
//             kullanıma hazır hale gelir. Sincan’daki tüm mahallelere aynı gün
//             servis imkânımız vardır.
//           </p>

//           <p>
//             Hizmet bölgelerimiz arasında Törekent, Yenikent, Fatih, Osmanlı,
//             Yunus Emre, Saraycık ve Atatürk mahalleleri bulunmaktadır. Mobil
//             temizlik ekiplerimiz haftanın 6 günü Sincan'ın tüm bölgelerinde
//             aktiftir.
//           </p>

//           <p>
//             Hemen <strong>İletişim</strong> sayfamızdan bize ulaşarak sipariş
//             verebilir, <strong>sincan halı yıkamacı fiyatı</strong> ya da{" "}
//             <strong>sincan yerinde koltuk yıkama ücreti</strong> gibi
//             detaylara kolayca ulaşabilirsiniz.
//           </p>

//           <SincanSidebar />
//           <SincanServiceArea />
//         </div>

//         {/* Sol Sidebar */}
//         <div className="order-2 md:order-1 space-y-6">
//           <LeftSidebar />
//         </div>

//         {/* Sağ Sidebar */}
//         <div className="order-3 md:order-3 space-y-6">
//           <RightSidebar />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SincanIntro;
import React from "react";
import SincanSidebar from "../Sidebar/SincanSidebar";
import SincanServiceArea from "../ServiceAreas/SincanServiceArea";
import RightSidebar from "../../Sidebars/RightSidebar";
import LeftSidebar from "../../Sidebars/LeftSidebar";

const SincanIntro = () => {
  return (
        <section className="relative overflow-hidden mt-[-95px] bg-gradient-to-b from-[#f8fafc] via-[#fffaf0] to-[#eef7f1] pt-0 px-4 pb-12">
      <div className="relative max-w-screen-xl mx-auto">
        <div className="mb-8 text-center pt-8">
          <span className="inline-flex rounded-full border border-[#d6b56d]/50 bg-white/90 px-5 py-2 text-sm font-bold text-[#6b3b16] shadow-sm">
            Sincan Halı Yıkama Hizmeti
          </span>

          <h1 className="mt-5 text-3xl md:text-5xl font-extrabold tracking-tight text-[#1f160f]">
            Sincan Halı Yıkama ve Koltuk Yıkama
          </h1>

          <p className="mx-auto mt-5 max-w-4xl text-base md:text-lg leading-8 text-gray-700">
            <strong>Sincan halı yıkama</strong> hizmetinde Abone Halı Yıkama;
            hijyenik temizlik, yerinden alım, zamanında teslim ve profesyonel
            koltuk yıkama çözümleri sunar. Törekent, Yenikent, Fatih, Osmanlı,
            Yunus Emre, Saraycık ve Atatürk mahallelerinde hizmet veriyoruz.
          </p>

          <div className="mt-6 flex flex-col sm:flex-row justify-center gap-3">
            <a
              href="tel:05015336066"
              className="rounded-full bg-[#2f160b] px-7 py-3 text-sm font-bold text-[#f8e6b2] shadow-lg hover:scale-105 transition"
            >
              Hemen Ara (0501 533 60 66)
            </a>

            <a
              href="https://wa.me/905015336066"
              className="rounded-full bg-green-600 px-7 py-3 text-sm font-bold text-white shadow-lg hover:scale-105 transition"
            >
              WhatsApp Teklif Al
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-7 items-start">
          <aside className="order-2 lg:order-1 lg:col-span-3 lg:sticky lg:top-28 space-y-6">
            <div className="rounded-[26px] border border-[#e7d7b4] bg-white/90 p-4 shadow-[0_18px_50px_rgba(15,23,42,0.08)]">
              <LeftSidebar />
            </div>
          </aside>

          <main className="order-1 lg:order-2 lg:col-span-6">
            <article className="rounded-[30px] border border-[#ead9b7] bg-white/95 p-6 md:p-8 shadow-[0_25px_70px_rgba(15,23,42,0.10)]">
              <div className="space-y-5 text-[16px] leading-8 text-gray-700 text-justify">
                <h2 className="text-2xl md:text-3xl font-bold text-[#1f160f] text-left">
                  Sincan’da Profesyonel Halı Yıkama
                </h2>

                <p>
                  Abone Halı Yıkama, Sincan bölgesinde halı yıkama, koltuk
                  yıkama, perde yıkama, yorgan ve battaniye yıkama hizmetlerinde
                  hijyen odaklı profesyonel çözümler sunar. Halılarınız evinizden
                  teslim alınır, türüne göre uygun yöntemle yıkanır, kurutulur ve
                  paketlenerek teslim edilir.
                </p>

                <p>
                  Evde çocuk, yaşlı veya alerjik bireyler varsa halı ve koltuk
                  temizliği yalnızca görüntü için değil sağlık açısından da
                  önemlidir. Bu nedenle Sincan halı yıkama hizmetimizde toz,
                  kötü koku, leke ve alerjen temizliği öncelikli olarak ele
                  alınır.
                </p>

                <div className="my-7 rounded-2xl border border-emerald-100 bg-emerald-50/80 p-5">
                  <h3 className="text-xl font-bold text-[#0f3d2e] mb-4">
                    Neden Abone Halı Yıkama?
                  </h3>

                  <ul className="grid gap-3 text-left">
                    <li>✓ Sincan genelinde yerinden alım ve teslimat</li>
                    <li>✓ Halı, koltuk, perde, yorgan ve battaniyede tam çözüm</li>
                    <li>✓ Antibakteriyel ve hijyen odaklı temizlik</li>
                    <li>✓ Leke, koku, toz ve alerjenlere karşı detaylı yıkama</li>
                    <li>✓ Yerinde koltuk yıkama ve fabrikada halı yıkama</li>
                    <li>✓ Şeffaf fiyatlandırma ve zamanında teslim</li>
                  </ul>
                </div>

                <h2 className="text-2xl font-bold text-[#1f160f] text-left">
                  Sincan Koltuk Yıkama ve Yerinde Temizlik
                </h2>

                <p>
                  Sincan koltuk yıkama hizmetimizde kumaş yapısına uygun
                  temizlik ürünleri, güçlü vakum makineleri ve buhar destekli
                  sistemler kullanılır. Koltuk yüzeyinde biriken kir, leke, kötü
                  koku ve alerjenler kumaşa zarar vermeden temizlenir.
                </p>

                <h2 className="text-2xl font-bold text-[#1f160f] text-left">
                  Sincan Perde, Yorgan ve Battaniye Yıkama
                </h2>

                <p>
                  Stor perde, zebra perde, tül perde, yorgan ve battaniye gibi ev
                  tekstili ürünleriniz için de hijyenik yıkama çözümleri
                  sunuyoruz. Ürünleriniz yapısına uygun yöntemlerle temizlenir ve
                  teslimata hazır hale getirilir.
                </p>

                <h2 className="text-2xl font-bold text-[#1f160f] text-left">
                  Sincan’da Hizmet Verdiğimiz Bölgeler
                </h2>

                <p>
                  Törekent, Yenikent, Fatih, Osmanlı, Yunus Emre, Saraycık,
                  Atatürk, Plevne, Akşemsettin, Gazi Osman Paşa ve Sincan’ın
                  birçok mahallesinde hızlı servis hizmeti sağlıyoruz.
                </p>

                <div className="rounded-2xl bg-[#fff7df] border border-[#ead9b7] p-5">
                  <h3 className="text-xl font-bold text-[#2b160b] mb-3">
                    Sincan Halı Yıkama Fiyatları
                  </h3>
                  <p>
                    Sincan halı yıkama fiyatları; halının türüne, ölçüsüne, leke
                    durumuna ve talep edilen ek hizmetlere göre değişebilir.
                    Net fiyat bilgisi için bizi arayabilir veya WhatsApp
                    üzerinden ölçü ve hizmet talebinizi iletebilirsiniz.
                  </p>
                </div>

                <p>
                  Abone Halı Yıkama olarak amacımız yalnızca halılarınızı
                  temizlemek değil; evinizde daha ferah, hijyenik ve sağlıklı bir
                  yaşam alanı oluşturmaktır. Sincan halı yıkama ve koltuk yıkama
                  hizmetleri için hemen iletişime geçebilirsiniz.
                </p>
              </div>

              <div className="mt-8 space-y-6">
                <SincanSidebar />
                <SincanServiceArea />
              </div>
            </article>
          </main>

          <aside className="order-3 lg:col-span-3 lg:sticky lg:top-28 space-y-6">
            <div className="rounded-[26px] border border-[#e7d7b4] bg-white/90 p-4 shadow-[0_18px_50px_rgba(15,23,42,0.08)]">
              <RightSidebar />
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default SincanIntro;